import { Button, Colors, IcFolderOutlined, IcGrid, IcList, IcUpload, InputSearch } from 'basic-ui-lib';
import React, { useCallback, useRef } from 'react';
import styled from 'styled-components';
import { ViewMode } from 'modules/media/services/hooks/useViewMode';
import { Breadcrumb } from '../Breadcrumb';
import UploadImageOrVideoModal, { UploadImageOrVideoModalRef } from '../UploadImageOrVideoModal';
import CreateFolderModal, { CreateFolderModalRef } from '../CreateFolderModal';
import useDebounce from 'hooks/useDebounce';
import useGetManageLibrary from 'modules/media/services/hooks/useGetManageLibrary';
import { BreadcrumbPath } from 'modules/media/services/hooks/useMediaExplorer';
// import { AddNewLinkModalRef } from '../../LinkList/AddNewLinkModal';
interface MediaManagerGalleryModeProps {
  viewMode?: ViewMode;
  onChangeViewMode?: (mode: ViewMode) => void;
  path: BreadcrumbPath[];
  onBack: () => void;
  currentPath: string;
  onSuccess: (currentPath: string) => void;
  onSuccessFolder?: () => void;
}

const MediaManagerGalleryMode = ({ viewMode, onChangeViewMode, path, onBack, currentPath, onSuccess, onSuccessFolder }: MediaManagerGalleryModeProps) => {
  const uploadImageOrVideoModalRef = useRef<UploadImageOrVideoModalRef>(null);
  const createFolderModalRef = useRef<CreateFolderModalRef>(null);
  // const addNewLinkRef = useRef<AddNewLinkModalRef>(null);
  
  const [, mutate] = useGetManageLibrary(true);

  const onSearchDebounce = useCallback((value: string) => {
    mutate(currentPath, value);
  }, []);

  const handleUploadImageOrVideo = () => {
    uploadImageOrVideoModalRef.current?.open(currentPath);
  };

  const handleCreateNewFolder = () => {
    createFolderModalRef.current?.open(currentPath);
  };

   const { text: searchText, setText: setSearchText } = useDebounce({
    timeDebounce: 600,
    onDebounce: onSearchDebounce,
  });
  
  // const handleAddNewLink = () => {
  //   addNewLinkRef.current?.open(currentPath);
  // };
  return (
    <Container>
      {path.length > 0 ? <Breadcrumb path={path} onBack={onBack} /> : <InputSearch placeholder='Search media...' value={searchText} onChange={(value) => setSearchText(value)} />}
      <Button type_primary lg prefix={<IcFolderOutlined width={20} height={20} fill={Colors.neutral.bg[1]} />} onClick={handleCreateNewFolder}>
        New Folder
      </Button>
      {/* <Button
          lg
          type_new
          prefix={<IcUpload width={20} height={20} fill={Colors.primary[5]} />}
          onClick={handleAddNewLink}
        >
          Add Link
        </Button> */}
      <Button type_second lg prefix={<IcUpload width={20} height={20} fill={Colors.neutral.bg[1]} />} onClick={handleUploadImageOrVideo}>
        Upload Image/Video
      </Button>
      <Button
        {...(viewMode === 'list' ? { type_new: true } : { type_ghost: true })}
        lg
        className='custom-button'
        onClick={() => onChangeViewMode && onChangeViewMode('list')}
      >
        <IcList width={24} height={24} fill={viewMode === 'list' ? Colors.primary[5] : undefined} />
      </Button>
      <Button
        {...(viewMode === 'grid' ? { type_new: true } : { type_ghost: true })}
        lg
        className='custom-button'
        onClick={() => onChangeViewMode && onChangeViewMode('grid')}
      >
        <IcGrid width={24} height={24} fill={viewMode === 'grid' ? Colors.primary[5] : undefined} />
      </Button>
      <UploadImageOrVideoModal ref={uploadImageOrVideoModalRef} onSuccess={onSuccess} />
      <CreateFolderModal ref={createFolderModalRef} onSuccess={onSuccess} onSuccessFolder={onSuccessFolder} />
      {/* <AddNewLinkModal ref={addNewLinkRef} /> */}
    </Container>
  );
};

export default MediaManagerGalleryMode;

const Container = styled.div`
  display: flex;
  gap: 16px;

  .custom-text {
    white-space: nowrap;
  }

  .custom-button {
    padding: 0 12px;
    height: 48px;

    .custom-text {
      line-height: 0;
    }
  }
`;
